import React from 'react';
import { twMerge } from 'tailwind-merge';

// Reusable paragraph component for section subtitles
const Subtitle = ({ children, className }) => (
  <p className={twMerge('text-md md:text-xl font-normal text-[#6F6F6F] text-center md:text-left', className)}>
    {children}
  </p>
);

export default Subtitle;
